module.exports = __webpack_public_path__ + "static/media/infiniteplayause_h.1e8bd22b.png";